<template lang="pug">

    div

        // Allgemeine Angaben
        // Nur anzeigen wenn mehrere Fieldsets vorhanden sind
        table.ui.small.very.basic.table(v-if="fieldSets.length > 1")

            colgroup(v-if="labelWidth")
                col(v-bind:width="labelWidth + '%'")
                col

            tbody

                //- Produkt-Typ
                //- Wird in Lieferantenansicht benoetigt
                tr(v-if="productTypeModel")
                    td: strong Produktart
                    td {{ productTypeModel.name }}

                //- Auflagen
                tr
                    td: strong Auflagen
                    td {{ printings }}

                //- Sorten
                tr(v-for='(sort, index) in variantModel.sorts')
                    td: strong Sorte {{ index+1 }}
                    td {{ sort }}


        // Variantenspezifikationen
        table.ui.small.very.basic.table(v-for='fieldSet in fieldSets' v-bind:key="fieldSet.id")

            colgroup(v-if="labelWidth")
                col(v-bind:width="labelWidth + '%'")
                col

            tbody

                //- Produkt-Typ
                //- Wird in Lieferantenansicht benoetigt
                //- Nur anzeigen wenn _nicht_ mehrere Fieldsets vorhanden sind
                tr(v-if="productTypeModel && fieldSets.length === 1")
                    td: strong Produktart
                    td {{ productTypeModel.name }}

                //- Auflagen
                //- Nur anzeigen wenn _nicht_ mehrere Fieldsets vorhanden sind
                tr(v-if="fieldSets.length === 1")
                    td: strong Auflagen
                    td {{ printings }}

                //- Sorten
                //- Nur anzeigen wenn _nicht_ mehrere Fieldsets vorhanden sind
                tr(v-if="fieldSets.length === 1" v-for='(sort, index) in variantModel.sorts')
                    td: strong Sorte {{ index+1 }}
                    td {{ sort }}

                // Formular-Namen
                // Nur anzeigen wenn mehrere Fieldsets vorhanden sind
                tr(v-if="fieldSets.length > 1")
                    td(colspan=2): strong {{ fieldSet.name }}

                //- Formularfelder
                tr(v-for='valueModel in fieldModels' v-if='belongsToFieldSet(fieldSet, valueModel)')
                    td: strong {{ valueModel.name }}
                    td
                        span(v-if="valueModel.prefix") {{ valueModel.prefix }}

                        i.ui.checkmark.icon(v-if='valueModel.value === "true"')
                        span(v-else-if='valueModel.value === false') Nein
                        span(v-else-if='valueModel.type === "COLOR"') {{ getColorCode(valueModel.value) }}
                        span(v-else) {{ valueModel.value }}

                        span(v-if="valueModel.suffix") {{ valueModel.suffix }}

</template>

<script>
    import * as R from 'ramda'
    import * as FormUtils from "@/utils/form"

    //noinspection JSUnusedGlobalSymbols
    export default {

        computed: {

            fieldSets() {
                return R.defaultTo([], this.formModel.fieldSets)
            },

            printings() {
                return R.compose(

                    // Verketten oder Default-Wert ausgeben
                    R.ifElse(
                        R.isNil, R.always('-'), R.join(', ')
                    ),

                    // Auflagen auslesen
                    R.prop('printings')

                )(this.variantModel)
            },

        },

        methods: {

            belongsToFieldSet(fieldSet, valueModel) {
                // Root-Level des Fieldsets ermitteln
                const fieldSetRootLevel = FormUtils.root_level(fieldSet.id)

                // Root-Level des Value-Models ermitteln
                const valueModelRootLevel = FormUtils.root_level(valueModel.key)

                return fieldSetRootLevel === valueModelRootLevel
            },

            getColorCode(value) {
                const sum = R.compose(

                    // Summer aus Elementen bilden
                    // > [ "4", "1", "0", "0" ]
                    // < 5
                    R.sum,

                    // In Array splitten
                    // > "4/1/0/0"
                    // < [ "4", "1", "0", "0" ]
                    R.split("/")

                )

                return R.compose(

                    // Zu String zusammenfuegen
                    // > [ 5, 4 ]
                    // < "5/4"
                    R.join("/"),

                    // Summe der Elemente bilden
                    // > [ "4/1/0/0",  "3/1/0/0" ]
                    // < [ 5, 4 ]
                    R.map(sum),

                    // In Array splitten
                    // > "4/1/0/0 3/1/0/0"
                    // < [ "4/1/0/0",  "3/1/0/0" ]
                    R.split(" ")

                )(value)
            },

        },

        props: {

            // TODO: In `valueModels` umbenennen
            fieldModels: {
                type: Array,
                required: true
            },

            formModel: {
                type: Object,
                required: true
            },

            labelWidth: {
                type: Number,
                required: false
            },

            productTypeModel: {
                type: Object,
                required: false
            },

            variantModel: {
                type: Object,
                required: true
            },

        }

    }

</script>

<style scoped>

    td {
        word-break: break-word;
    }

</style>
